import script from "./Forget.vue?vue&type=script&setup=true&lang=js"
export * from "./Forget.vue?vue&type=script&setup=true&lang=js"

import "./Forget.vue?vue&type=style&index=0&id=2893ce5a&scoped=true&lang=css"
script.__scopeId = "data-v-2893ce5a"

export default script